import DefaultSignInManualInstruction, {
  ManualSignInInstructionProps,
} from './DefaultSignInManualInstruction';
import { useManualSignInComponent } from './useManualSignInComponent';

const SignInManualInstruction = (props: ManualSignInInstructionProps) => {
  const ManualSignInComponent = useManualSignInComponent(
    props.payrollProvider.id,
  );

  if (ManualSignInComponent) {
    return <ManualSignInComponent {...props} />;
  }

  return <DefaultSignInManualInstruction {...props} />;
};

export default SignInManualInstruction;
